"use client";
import { chunkArray } from "@/utilities";
import { useContext, useEffect, useState } from "react";
import { NavigationContext } from "@/providers/navigationProvider";
import Link from "next/link";
import styles from './styles.module.scss';
import Search from "./Search";
import DaxkoBrands from "./DaxkoBrands";

const validateUrl = (url) => {
    try {
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
};

const MainMenu = () => {
    const context = useContext(NavigationContext);
    const { navItems, currentNavId, setOpen } = context || {};
    const [currentNavData, setCurrentNavData] = useState({});

    useEffect(() => {
        if (navItems) {
            const filteredNavData = navItems.filter(item => item.id === currentNavId);
            setCurrentNavData(filteredNavData.length > 0 ? filteredNavData[0] : {});
        }
    }, [navItems, currentNavId]);

    const handleClick = () => {
        setOpen(false);
    }

    const renderItems = (subnavItem) => {
        return subnavItem && subnavItem.map((item, index) => {
            const { label, url, children, menuFields, target } = item || {};
            const urlObj = validateUrl(url) ? new URL(url) : {};
            const externalUrl = !url?.includes(`daxkocms`);
            const path = externalUrl ? url : urlObj?.pathname || `#`;

            const renderCopy = () => {
                const copy = menuFields?.menuItemBlurb;
                if (!copy) return null;
                return (
                    <div className={`${styles.mainMenu__copy} ${children?.length === 0 ? 'adjust_left' : ''}`} dangerouslySetInnerHTML={{ __html: copy || " " }} />
                );
            }
            return (
                <div className={styles.mainMenu__item} key={index}>
                    <div className={`${styles.mainMenu__top}  ${path !== `#` ? "top_icon" : ""}`}>
                        {path !== `#` && (
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.6665 4L11.2565 5.41L16.8365 11H4.6665V13H16.8365L11.2565 18.59L12.6665 20L20.6665 12L12.6665 4Z" fill="#E8236B" />
                            </svg>
                        )}
                        <Link onClick={()=>{handleClick()}} href={path || `#`} target={target || `_self`} className={`${styles.mainMenu__topTitle} ${path !== `#` ? "bold" : ""}`}>
                            {label}
                        </Link>
                    </div>
                    {renderCopy()}
                    <ul className={styles.mainMenu__sub}>
                        {children && children.map((childItem, ) => {
                            const { label, url, target } = childItem || {};
                            const urlObj = validateUrl(url) ? new URL(url) : {};
                            const externalUrl = !url?.includes(`daxkocms`);
                            const path = externalUrl ? url : urlObj?.pathname || `#`;

                            return (
                                <li key={path} className={styles.mainMenu__subItem}>
                                    <Link onClick={()=>{handleClick()}} href={path || `#`} target={target || "_self"}>
                                        {externalUrl ?
                                            (<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.16667 17.5C3.70833 17.5 3.31611 17.3369 2.99 17.0108C2.66389 16.6847 2.50056 16.2922 2.5 15.8333V12.5H4.16667V15.8333H15.8333V4.16667H4.16667V7.5H2.5V4.16667C2.5 3.70833 2.66333 3.31611 2.99 2.99C3.31667 2.66389 3.70889 2.50056 4.16667 2.5H15.8333C16.2917 2.5 16.6842 2.66333 17.0108 2.99C17.3375 3.31667 17.5006 3.70889 17.5 4.16667V15.8333C17.5 16.2917 17.3369 16.6842 17.0108 17.0108C16.6847 17.3375 16.2922 17.5006 15.8333 17.5H4.16667ZM8.75 14.1667L7.58333 12.9583L9.70833 10.8333H2.5V9.16667H9.70833L7.58333 7.04167L8.75 5.83333L12.9167 10L8.75 14.1667Z" fill="#E8236B" />
                                            </svg>)
                                            :
                                            (<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.6665 4L11.2565 5.41L16.8365 11H4.6665V13H16.8365L11.2565 18.59L12.6665 20L20.6665 12L12.6665 4Z" fill="#E8236B" />
                                            </svg>)
                                        }
                                        <span>
                                            {label}
                                        </span>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        });
    }

    const renderColumns = () => {
        const subnav = currentNavData?.children;

        let chunkSize = currentNavData?.label === "Company" ? 3 : 1;
        if (subnav) {
            const chunkedSubNav = chunkArray(subnav, chunkSize);
            return chunkedSubNav && chunkedSubNav.map((subnavItem, index) => {
                return (
                    <div key={index} className={styles.mainMenu__col}>
                        {renderItems(subnavItem)}
                    </div>
                );
            })
        }

    }

    return (
        <div className={styles.mainMenu}>
            <div className={styles.mainMenu__inner}>
                {renderColumns()}
                {currentNavData?.label === "Company" && (<DaxkoBrands />)}
            </div>
            {currentNavData?.label === "Resources" && (<Search />)}
        </div>
    );

}

export default MainMenu;
